<template>
  <div :class="_.actions">
    <button
      v-if="item.status === 2"
      v-track="{
        name: '拼团-我的订单-邀请好友',
        id: '86c1c2bd-d2b2-4dbf-8b22-f4d52f6b7b2f',
        content: orderNo,
      }"
      :class="_.red"
      @click="handleInviteClick"
    >
      邀请好友
    </button>
    <button
      v-if="item.status === 0"
      v-track="{
        name: '拼团-我的订单-取消订单',
        id: '28ac8a40-5fa6-4cdd-8070-0ebbec8602dc',
        content: orderNo,
      }"
      @click="handleCancelClick"
    >
      取消订单
    </button>
    <button
      v-if="item.status === 0"
      v-track="{
        name: '拼团-我的订单-立即支付',
        id: '21b45dff-d986-473c-8c4e-7504f64fa59e',
        content: orderNo,
      }"
      :class="_.red"
      @click="handlePayClick"
    >
      立即支付
    </button>
    <button
      v-if="item.status === 4"
      v-track="{
        name: '拼团-我的订单-删除团单',
        id: '2bc4dce2-76a7-4596-9bf4-95d66bed6838',
        content: orderNo,
      }"
      @click="handleDeleteClick"
    >
      删除团单
    </button>
    <button
      v-if="!noDetail && (item.status === 3 || item.status === 4)"
      v-track="{
        name: '拼团-我的订单-查看详情',
        id: 'bba1c7fe-8b08-47e1-8502-8b67e4a952e9',
        content: orderNo,
      }"
      :class="_.red"
      @click="handleDetailClick"
    >
      查看详情
    </button>
  </div>
</template>

<script>
  import {
    apiGroupBuyingOrderCancel,
    apiGroupBuyingOrderDelete,
    apiGroupBuyingOrderPay,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { Dialog } from 'vant'
  import { globalModel } from '@/model'
  import { GroupBuyingUtils } from '../../utils'
  import { navigateTo } from '@/router'
  import { submit } from '@/utils'

  export default {
    props: {
      // 条目
      item: {
        type: Object,
        required: true,
      },
      // 是否无查看详情按钮
      noDetail: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      // 订单号
      orderNo() {
        return this.item.orderId
      },
    },

    methods: {
      // 点击邀请好友
      handleInviteClick() {
        GroupBuyingUtils.share({
          goodsName: this.item.commodityName,
          goodsPrice: this.item.unitPrice,
          goodsCover: this.item.commodityPic,
          groupOrderId: this.item.groupOrderId,
          remainingCount: this.item.grouped ? 0 : this.item.differCount,
        })
      },

      // 点击取消订单
      async handleCancelClick() {
        await submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确定取消此订单吗？',
          })
          await $.start()
          await apiGroupBuyingOrderCancel({
            orderId: this.orderNo,
          })
          this.$emit('refresh', { trigger: 'cancel' })
          await $.success('订单已取消')
        })
      },

      // 点击支付
      async handlePayClick() {
        await submit(async $ => {
          await $.start()
          const payData = await apiGroupBuyingOrderPay({
            orderId: this.orderNo,
            payType: globalModel.state.payType,
            openId: globalModel.state.openid,
          })
          await dcb.requestPayment({
            provider: 'native',
            showNativeResultPage: false,
            params: payData,
          })
          this.$emit('refresh')
          await $.success('支付成功')
        })
      },

      // 点击删除团单
      async handleDeleteClick() {
        await submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确定删除此订单吗？',
          })
          await $.start()
          await apiGroupBuyingOrderDelete({
            orderId: this.orderNo,
          })
          this.$emit('refresh', { trigger: 'delete' })
          await $.success('订单已删除')
        })
      },

      // 点击查看详情
      handleDetailClick() {
        navigateTo(
          this.item.status === 3 ? 'OrderDetail' : 'GroupBuyingOrderDetail',
          {
            orderNo:
              this.item.status === 3 ? this.item.mallOrderNo : this.orderNo,
          },
        )
      },
    },
  }
</script>

<style lang="scss" module>
  .actions {
    text-align: right;
    font-size: 0;

    button {
      border-radius: 17px;
      border: 1px solid rgba(190, 190, 190, 0.93);
      background-color: transparent;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      padding: 5px 15px;
      margin-left: 12px;

      &.red {
        color: #ffffff;
        background: #ff111c;
        border: 1px solid #ff111c;
      }

      &:active {
        opacity: 0.8;
      }
    }

    &:empty {
      display: none !important;
    }
  }

  .hidden {
    display: none;
  }
</style>
